import { I2cTextarea } from "@webcomponents/i2cwebcomponents/dist/react";
import React, { useEffect } from "react";
import "../Prepaid.scss";

const AdditionalComment = ({
  setAddFormData,
  addFormData,
  formDataJson,
  setFormValidStates,
  isFetching,
}) => {
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      setAddFormData({
        ...addFormData,
        8: {
          "8_0": {
            additional_comment:
              formDataJson["8"]["8_0"]?.additional_comment ?? "",
          },
        },
      });
    }
  }, [isFetching]);
  return (
    <React.Fragment>
      <div i2c-grid="grid gap-sm">
        <div i2c-grid="12">
          <div className="custom-label-light mb-16">
            If there is any detail that was not covered in the sections above,
            please mention it here in this section.
          </div>
          <I2cTextarea
            name="additionalComment"
            label=""
            autofocus
            resize="none"
            value={
              addFormData["8"]
                ? addFormData["8"]["8_0"]?.additional_comment
                : ""
            }
            onI2cInput={(e) => {
              setFormValidStates("8_0", true);
              setAddFormData({
                ...addFormData,
                8: {
                  "8_0": { additional_comment: e?.target?.value ?? "" },
                },
              });
            }}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdditionalComment;
